import { useState, lazy, Suspense } from 'react';
import { Search } from 'lucide-react';
import { Button } from '@/components/ui/button';

// cmdk (+ its nested Radix copies, ~43 KB raw / ~15 KB gzip) is only needed once
// the user actually opens search. Lazy-load the dialog on first open so it stays
// off the every-page critical path.
const HeaderSearchDialog = lazy(() => import('./HeaderSearchDialog'));

interface HeaderSearchProps {
  onSearch: (value: string) => void;
}

const HeaderSearch = ({ onSearch }: HeaderSearchProps) => {
  const [isOpen, setIsOpen] = useState(false);
  // Stays true after the first open so the dialog (and its loaded chunk +
  // autocomplete query cache) remain mounted; `isOpen` toggles visibility.
  const [hasOpened, setHasOpened] = useState(false);

  const openDialog = () => {
    setHasOpened(true);
    setIsOpen(true);
  };

  return (
    <>
      <Button
        variant="outline"
        className="w-full justify-start text-left font-normal"
        onClick={openDialog}
      >
        <Search className="mr-2 h-4 w-4" />
        <span>Search products...</span>
      </Button>

      {hasOpened && (
        <Suspense fallback={null}>
          <HeaderSearchDialog open={isOpen} onOpenChange={setIsOpen} onSearch={onSearch} />
        </Suspense>
      )}
    </>
  );
};

export default HeaderSearch;
